import React, { ReactElement } from 'react';

import useEditNameModalContainer from 'adapter/in/dashboards/containers/Modals/EditNameModal/useEditNameModalContainer';
import SingleNameInputModal, { CreateNameFormData } from 'adapter/in/common/components/SingleNameInputModal/SingleNameInputModal';
import i18n from 'asset/translation';
import gtmIds from 'adapter/in/dashboards/config/gtm';

const gtm = gtmIds.dashboard.editNameModal;

const EditDashboardNameModalContainer = (): ReactElement => {
    const { dashboardOriginalName, onSubmit, showModal, onModalCancel, isLoading, error, success } = useEditNameModalContainer();

    const onInternalSubmit = (data: CreateNameFormData) => {
        onSubmit(data.name);
    };

    return (
        <SingleNameInputModal
            title={i18n.t('dashboards.edit.renameModalTitle')}
            defaultValue={dashboardOriginalName}
            success={success}
            handleOnSubmit={onInternalSubmit}
            showModal={showModal}
            handleCloseModal={onModalCancel}
            isLoading={isLoading}
            error={error}
            message={i18n.t('dashboards.create.name')}
            dataIdContext={{ tryAgain: gtm.actions.tryAgain, inputName: gtm.inputName, main: gtm.actions.save, cancel: gtm.actions.cancel }}
        />
    );
};

export default EditDashboardNameModalContainer;
